import { IStyle, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import { IProductReview } from '../../../../entities-generated/common/product-review';
import { RatingBar } from '../../../components/rating-bar';

interface IRatingBreakdownProps {
  review: IProductReview;
  style?: React.CSSProperties;
}

const getStyleClasses = () => {
  const root: IStyle = {
    width: '100%',

    '& > div': {
      marginBottom: '0.75rem',
    },
  };

  return mergeStyleSets({
    root,
  });
}

export const RatingBreakdown: React.FunctionComponent<IRatingBreakdownProps> = (props) => {
  const cs = getStyleClasses();
  const { review } = props;

  return (
    <div className={cs.root}>
      {review.oneRatingsCount > 0 &&
      <RatingBar rating={1} reviewerCount={review.oneRatingsCount} />}
      {review.twoRatingsCount > 0 &&
      <RatingBar rating={2} reviewerCount={review.twoRatingsCount} />}
      {review.threeRatingsCount > 0 &&
      <RatingBar rating={3} reviewerCount={review.threeRatingsCount} />}
      {review.fourRatingsCount > 0 &&
      <RatingBar rating={4} reviewerCount={review.fourRatingsCount} />}
      {review.fiveRatingsCount > 0 &&
      <RatingBar rating={5} reviewerCount={review.fiveRatingsCount} />}
    </div>
  );
};
